export interface IDecayCalibrationType {
  Id: number;
  Name: string;
  Description: string;
}

export enum DecayCalibrationType {
  AvgVintageBalance = 1,
  AvgOpenAccounts = 2,
  AvgClosedAccounts = 3
}
